import styled, { css } from 'styled-components';

import Text, { TextProps } from '~components/Text';
import { getFontStyle } from '~components/Text/helper';
import { StyleType } from '~types/common';

export const S = {
  TextareaWrapper: styled.div<{ fullWidth?: boolean }>`
    position: relative;
    width: 320px;
    display: flex;
    flex-direction: column;

    ${({ fullWidth }) =>
      fullWidth &&
      css`
        width: 100%;
      `}
    ${({ theme }) => theme.media.mobile} {
      width: 100%;
    }
  `,
  StyledTextarea: styled.textarea<{ hasError?: boolean; inputCss?: StyleType }>`
    height: 48px;
    border: 1px solid ${({ theme }) => theme.colors.gray400};
    background-color: white;
    border-radius: 4px;
    padding: 12px 16px;
    color: ${({ theme }) => theme.colors.gray900};
    font-size: 16px;
    cursor: pointer;
    resize: none;

    /* Chrome, Safari, Edge, Opera */
    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    /* firefox */
    [type='number'] {
      -moz-appearance: textfield;
    }

    &:focus {
      border-color: ${({ theme }) => theme.colors.gray600};
      outline: none;
    }

    &::placeholder {
      color: ${({ theme }) => theme.colors.gray600};
      ${getFontStyle('midium150_B1')};
      font-size: 16px;
    }

    ${(props) =>
      props.hasError &&
      css`
        border: 1px solid ${({ theme }) => theme.colors.red500};
      `};

    ${({ inputCss }) => inputCss}
  `,
  Label: styled.label`
    text-align: left;
    ${getFontStyle('midium150_B3')};
  `,
  Unit: styled(Text)<{ hasError?: boolean } & TextProps>`
    position: absolute;
    right: 13px;
    bottom: 17px;

    ${(props) =>
      props.hasError &&
      css`
        bottom: 33px;
      `}
  `,
  Error: styled(Text)<TextProps>`
    color: ${({ theme }) => theme.colors.red500};
    text-align: left;
    font-size: 12px;
    padding-top: 4px;
  `,
};
